import React from 'react';
import Drawer from '@mui/material/Drawer';
import { Box } from '@mui/material';
import Sidebar from '../../SideBar';
import './mobile.scss';

const MobileDrawer = ({ openMenu, setOpenMenu }) => {
  return (
    <Drawer
      open={openMenu}
      onClose={() => setOpenMenu(false)}
      anchor='right'
      transitionDuration={250}
    >
      <Box className='sidebarContainer'>
        <Sidebar openMenu={openMenu} closeMenu={() => setOpenMenu(false)} />
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
